
import { Link } from 'react-router-dom';

export default function FAQHero() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-teal-700 via-teal-800 to-teal-900 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-amber-400 rounded-full blur-3xl"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-6 text-center">
        <nav className="flex items-center justify-center gap-2 text-sm text-white/70 mb-8">
          <Link to="/" className="hover:text-white transition-colors cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-white font-medium">FAQ</span>
        </nav>
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/10 backdrop-blur-sm text-white text-sm font-semibold rounded-full mb-6">
          <i className="ri-question-answer-line"></i>
          Frequently Asked Questions
        </div>
        <h1 className="text-5xl font-bold text-white mb-5">
          Roseville <span className="text-amber-400">FAQ</span>
        </h1>
        <p className="text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          Everything you need to know about living, working, and thriving in Roseville, California — from moving tips to business listings.
        </p>
      </div>
    </section>
  );
}
